module.exports = __webpack_public_path__ + "img/kg.e588bab.svg";